import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import Link from "next/link";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import type { RatingsSectionProps, RatingsData } from "./types";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
interface ParticipationDropRatingsVoterSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
}
export default function ParticipationDropRatingsVoterSection(t0) {
  const $ = _c(15);
  const {
    drop,
    ratingsData
  } = t0;
  const {
    hasRaters
  } = ratingsData;
  let t1;
  if ($[0] !== drop.raters_count || $[1] !== drop.top_raters || $[2] !== drop.wave || $[3] !== hasRaters) {
    t1 = hasRaters && <div className="tw-flex tw-items-center -tw-space-x-1.5">{drop.top_raters.slice(0, 5).map((rater, index) => {
        if (!rater.profile.pfp) {
          return null;
        }
        const raterLabel = rater.profile.handle ?? rater.profile.primary_address;
        return <div key={rater.profile.id}><div className="tw-relative tw-transition-transform hover:tw-z-10 hover:tw-scale-110" style={{
            zIndex: drop.top_raters.length - index
          }} data-tooltip-id={`participation-rater-${rater.profile.id}`}><Link href={`/${raterLabel}`}><img src={getScaledImageUri(rater.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${raterLabel}'s avatar`} className="tw-h-5 tw-w-5 tw-rounded-md tw-bg-iron-800 tw-object-contain tw-ring-1 tw-ring-black" /></Link></div><Tooltip id={`participation-rater-${rater.profile.id}`} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{raterLabel} • {formatNumberWithCommas(rater.rating)}{" "}{WAVE_VOTING_LABELS[drop.wave.voting_credit_type]}</Tooltip></div>;
      })}{drop.raters_count > 5 && <div className="tw-relative tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-md tw-bg-iron-900 tw-text-[10px] tw-font-medium tw-text-iron-300 tw-ring-1 tw-ring-white/10 tw-transition-transform hover:tw-scale-110">+{drop.raters_count - 5}</div>}</div>;
    $[0] = drop.raters_count;
    $[1] = drop.top_raters;
    $[2] = drop.wave;
    $[3] = hasRaters;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== drop.raters_count) {
    t2 = <span className="tw-font-medium tw-text-iron-50">{drop.raters_count}</span>;
    $[5] = drop.raters_count;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = drop.raters_count === 1 ? "voter" : "voters";
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="tw-font-normal tw-text-iron-400">{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <span>{t2}{" "}{t4}</span>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-text-sm tw-leading-5">{t1}{t5}</div>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}